module.exports = __webpack_public_path__ + "static/media/icon-contact-dribbble.ec16b4f8.svg";